import { render, staticRenderFns } from "./DriverLicense.vue?vue&type=template&id=75ef485c&"
import script from "./DriverLicense.vue?vue&type=script&lang=js&"
export * from "./DriverLicense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports